import { Button, Col, DatePicker, Form, Input, message, Row, Select, Space, Table, Tag } from 'antd';
import React, { useState } from 'react'
import ReportService from '../../services/ReportService';
import { render } from '@testing-library/react';
import DownloadCsv from '../Report/DailyReport/DownloadCsv';
import { SearchOutlined } from '@ant-design/icons';
import ResponseMessage from './Notification/ResponseMessge';

const OutwaredBinReportTable = ({ location }) => {

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [selectedType, setSelectedType] = useState();
    const [data, setData] = useState();
    const [form] = Form.useForm();
    const [searchText, setSearchText] = useState('');

    const columns = [
        {
            title: 'SI No.',
            dataIndex: 'si_no',
            key: 'si_no',

        },
        {
            title: 'Bin ID',
            dataIndex: 'bin_id',
            key: 'bin_id',
            render: (text) => text || "No Data"
        },
        {
            title: 'From',
            dataIndex: 'bin_from',
            key: 'bin_from',
            render: (text, record) => {
                const locationMap = {
                    'garment_super_market': 'Garment Super Market',
                    'dispatch_center': 'Dispatch Center',
                    'washing': 'Washing'
                };

                if (locationMap[text]) {
                    text = locationMap[text];
                }

                return text || "No Data";
            }
        },
        {
            title: 'To',
            dataIndex: 'bin_to',
            key: 'bin_to',
            render: (text, record) => {
                const locationMap = {
                    'garment_super_market': 'Garment Super Market',
                    'dispatch_center': 'Dispatch Center',
                    'washing': 'Washing'
                };

                if (locationMap[text]) {
                    text = locationMap[text];
                }

                return text || "No Data";
            }
        },
        {
            title: 'Added By',
            dataIndex: 'added_by',
            key: 'added_by',
            render: (text) => text || "No Data"
        },
        {
            title: 'Added On',
            dataIndex: 'added_on',
            key: 'added_on',
            render: (text) => text || "No Data"
        },
        {
            title: 'Received On',
            dataIndex: 'received_on',
            key: 'received_on',
            render: (text) => text || "No Data"
        },
        {
            title: 'Received By',
            dataIndex: 'received_by',
            key: 'received_by',
            render: (text) => text || "No Data"
        },
        {
            title: 'Status',
            dataIndex: 'movement_status',
            key: 'movement_status',
            render: (text) => text || "No Data"
        },
    ];

    const handleDateChange = (dateRange) => {
        if (!dateRange || !Array.isArray(dateRange)) {
            console.error("Invalid date range:", dateRange);
            setStartDate(null);
            setEndDate(null);
            return;
        }

        const [start_Date, end_Date] = dateRange;

        if (start_Date && end_Date) {
            setStartDate(start_Date.format("YYYY-MM-DD"));
            setEndDate(end_Date.format("YYYY-MM-DD"));
        } else {
            console.error("Invalid date range values:", dateRange);
            setStartDate(null);
            setEndDate(null);
        }
    };

    const handleTypeChange = (value) => {
        setSelectedType(value);
    };

    const handleClear = () => {
        form.resetFields();
        setStartDate(null);
        setEndDate(null);
        setSelectedType(null);
        setData([]);
    };

    const handleGetResult = async () => {
        console.log(startDate);
        console.log(endDate);
        console.log(selectedType);
        console.log(location);

        if (!startDate || !endDate || !selectedType || !location) {
            // message.error("Please provide all required inputs");
            ResponseMessage.error({ message: 'Please provide all required inputs' })
            return;
        }

        try {
            const response = await ReportService.get_inward_outward_report(startDate, endDate, selectedType, location);

            if (response && response.data) {
                const updatedData = response.data.map((item, index) => ({
                    si_no: index + 1,
                    ...item
                }));

                console.log(updatedData);
                setData(updatedData);

                message.warning(response.message);
            } else {
                console.error("Invalid response structure:", response);
                setData([]);
                ResponseMessage.error({ message: response?.message || "No data found." })
                // message.error(response?.message || "No data found.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            ResponseMessage.error({ message: error?.message || "Failed to fetch data." })
            // message.error(error?.message || "Failed to fetch data.");
            setData([]);
        }

    };

    const typeOptions = [
        {
            value: 'inward',
            label: 'Inwarded Bin'
        },
        {
            value: 'outward',
            label: 'Outwarded Bin'
        },
    ];

    const filteredData = Array.isArray(data)
        ? data.filter((item) =>
            item?.bin_id?.toString().toLowerCase().includes(searchText.toLowerCase())
        )
        : [];


    return (
        <>
            <Form layout="vertical" form={form}>
                <Row gutter={[16, 16]} align="middle">

                    <Col flex="auto">
                        <Form.Item label={<strong>Type</strong>} name='type'>
                            <Select
                                showSearch
                                placeholder="Select a Type"
                                options={typeOptions}
                                onChange={handleTypeChange}
                                value={selectedType}
                            />
                        </Form.Item>
                    </Col>
                    <Col flex="auto">
                        <Form.Item label={<strong>Select Date Range</strong>} name="dateRange">
                            <DatePicker.RangePicker
                                onChange={handleDateChange}
                            />
                        </Form.Item>
                    </Col>

                    <Col>
                        <Form.Item label='  '>
                            <Button type="primary" onClick={handleGetResult}>
                                Get Result
                            </Button>
                        </Form.Item>
                    </Col>

                    {/* Clear Button */}
                    <Col>
                        <Form.Item label='  '>
                            <Button danger onClick={handleClear}>
                                Clear
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>

                {/* Table Component */}
                <Row>
                    <Col span={24}>
                        <Table
                            title={() =>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Input
                                        placeholder="Search Bin ID"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        allowClear
                                        prefix={<SearchOutlined style={{ color: '#1890ff' }} />}
                                        style={{ width: 300 }}
                                    />
                                    <DownloadCsv
                                        flag={true}
                                        reportData={data}
                                        startDate={startDate}
                                        endDate={endDate}
                                    />
                                </div>}
                            columns={columns}
                            dataSource={filteredData}
                            size='small'
                        />
                    </Col>
                </Row>
            </Form>

        </>
    )
}

export default OutwaredBinReportTable